export const initialCardData = {
  dreamTeam: {
    title: "Dream Team",
    logo: "../../assets/community/logos/dream_team.png",
    quote:
      "Together, each year we join 12 youth from different parts of Northeast Florida and South Georgia who suffer from a variety of illnesses to serve on our Dream Team. The goal remains the same each year – to give these children and their families hope and fun experiences involving sports as they fight their medical battles!",
    url: "https://www.taxslayergatorbowl.com/news/dreamteam2024/",
    expanded: false,
    images: [
      "../../assets/community/images/DreamTeam/dreamteam1.jpg",
      "../../assets/community/images/DreamTeam/dreamteam2.jpg",
      "../../assets/community/images/DreamTeam/dreamteam3.jpg",
      "../../assets/community/images/DreamTeam/dreamteam4.jpg",
    ],
  },
  cia: {
    title: "Children in Action",
    logo: "../../assets/community/logos/cia.png",
    quote:
      "Children in action sports club practice, play, and pray, to learn lessons, so children and families can win.",
    url: "http://www.ciasportsclub.org/",
    expanded: false,
    images: [],
  },
  monique: {
    title: "Monique Edd Foundation",
    logo: "../../assets/community/logos/mbf.png",
    quote:
      "Educate and protect children and teens from all types of bullying, abuse, and other types of child victimization with our evidence-based and evidence-informed prevention education",
    url: "https://mbfpreventioneducation.org/",
    expanded: false,
    images: [
      "../../assets/community/images/Monique/Monique.jpg",
      "../../assets/community/images/Monique/monique2.jpg",
    ],
  },
  nefba: {
    title: "Northeast Florida Basketball Association",
    logo: "../../assets/community/logos/nefba.png",
    quote:
      "The Northeast Florida Basketball Association (NEFBA) is dedicated to providing a positive and competitive youth basketball experience.",
    url: "https://nefba.com/",
    expanded: false,
    images: [],
  },
  jtff: {
    title: "Jim and Tabitha Foundation",
    logo: "../../assets/community/logos/jtff.png",
    quote:
      "Helping the children within our communities achieve their dreams is what The Jim and Tabitha Foundation is all about.",
    url: "https://jimandtabithafurykfoundation.com/",
    expanded: false,
    images: [
      "../../assets/community/images/Furyk/furyk1.jpg",
      "../../assets/community/images/Furyk/furyk2.jpg",
      "../../assets/community/images/Furyk/furyk3.jpg",
    ],
  },
  apwa: {
    title: "American Public Works Association",
    logo: "../../assets/community/logos/apwa.png",
    quote:
      "To be an active, unified Public Works organization, providing leadership, education, training, direction and support on Public Works issues to its members, elected officials and the public, every day, as well as during times of natural disaster.",
    url: "https://florida.apwa.org/branch/northeast-florida-branch-dist-iv/",
    expanded: false,
    images: [],
  },
  gratitudeAmerica: {
    title: "Gratitude America",
    logo: "../../assets/community/logos/ga.png",
    quote:
      "Gratitude America provides critical support for service members, Veterans, and their families and conducts meaningful restorative retreats to assist participants affected by deployment exposures such as combat related stress and traumatic brain injury.",
    url: "https://gratitudeamerica.org/",
    expanded: false,
    images: ["../../assets/community/images/GratitudeAmerica/gratitude1.jpg"],
  },
  dailysFoundation: {
    title: "Daily's Foundation",
    logo: "../../assets/community/logos/df.png",
    quote:
      'Daily\'s has been supporting local charities in Northeast Florida for over 20 years and has built a strong reputation of commitment to making the community "nicer"',
    url: "https://dailys.com/pages/dailys-foundation",
    expanded: false,
    images: [],
  },
  fourH: {
    title: "4-H",
    logo: "../../assets/community/logos/4h.png",
    quote:
      "4-H is America’s largest youth development organization—empowering nearly six million young people with the skills to go beyond the expected. To Be Beyond Ready.",
    url: "https://4-h.org/",
    expanded: false,
    images: [],
  },
  navyLeague: {
    title: "U.S. Navy League",
    logo: "../../assets/community/logos/navyleague.png",
    quote:
      "The Navy League of the United States is a civilian organization dedicated to informing the American people and their government that the United States of America is a maritime nation and that its national defense and economic wellbeing are dependent upon strong sea services -- United States Navy, United States Marine Corps, United States Coast Guard and United States Merchant Marine.",
    url: "https://www.mayportnlus.org/",
    expanded: false,
    images: [],
  },
  GolfForeScott: {
    title: "Golf Fore Scott",
    logo: "../../assets/community/logos/gfs.png",
    quote:
      "Annual Charity Golf Tournament that raises money for colon cancer. All proceeds go to The Colorectal Cancer Alliance.",
    url: "https://www.facebook.com/people/Golf-Fore-Scott/100082993459207/#",
    expanded: false,
    images: [],
  },
  nothingFoundation: {
    title: "Nothin' But A E Thang Foundation",
    logo: "../../assets/community/logos/nothing_foundation.png",
    quote:
      "A foundation in supporting students looking to continue post high school education.",
    url: "https://www.instagram.com/nothinbutaethang/",
    expanded: false,
    images: [],
  },
  northFloridaBaseball: {
    title: "North Florida Baseball Association Inc.",
    logo: "../../assets/community/logos/nf_bb.png",
    quote:
      "A not for profit organization- solely in operation for the purpose to serve our youth and let them play ball! Our organization is based out of Middleburg, FL with the goal to emphasize the importance of hard work, healthy competition and fun. Our association currently supports your 12u and 10u Black Creek Cottonmouths Baseball Team.",
    url: "https://www.facebook.com/Blackcreekcottonmouths/",
    expanded: false,
    images: [],
  },
  bakerWildcats: {
    title: "Baker County AYF Wildcats",
    logo: "../../assets/community/logos/baker_wildcats.png",
    quote: "Baker County Wildcats sponsorship.",
    url: "",
    expanded: false,
    images: [],
  },
  middleburgWrestling: {
    title: "Middleburg Wrestling",
    logo: "../../assets/community/logos/middleburg_wrestling.png",
    quote: "Middleburg High School Wrestling Sponsorship.",
    url: "",
    expanded: false,
    images: [],
  },
  jaxumForJessica: {
    title: "Jaxum for Jessica",
    logo: "../../assets/community/logos/jaxum_for_jessica.png",
    quote:
      "As a key player in the world of golf, Jessica embodies the passion, drive, and talent we stand behind. We can't wait to see her shine on the course and continue to inspire with her incredible skill and dedication. Let's go Jessica – this is just the beginning!",
    url: "",
    expanded: false,
    images: [
      "../../assets/community/images/Jessica/jessica1.jpg",
      "../../assets/community/images/Jessica/jessica2.jpg",
      "../../assets/community/images/Jessica/jessica3.jpg",
    ],
  },
  diskJax: {
    title: "Disk Jax, Inc.",
    logo: "../../assets/community/logos/discdare.png",
    quote:
      "Uniting Jacksonville’s recovery community through active outdoor fellowship, creating spaces rooted in connection, wellness, and shared purpose.",
    url: "https://www.discjax.com/dare2disc",
    expanded: false,
    images: [],
  },
  projectSavior: {
    title: "Project Savior",
    logo: "../../assets/community/logos/project_savior_logo.png",
    quote:
      "Our Mission is to fight veteran suicide through the outdoors and sharing the true freedom that comes through Jesus Christ!",
    url: "https://www.projectsavioroutdoors.org/",
    expanded: false,
    images: [],
  },
  gfwc: {
    title: "GFWC Woman's Club of MacClenny",
    logo: "../../assets/community/logos/gfwc.png",
    quote:
      "As part of the General Federation of Women's Clubs, we unite women from all walks of life to uplift our community. Our projects span health, education, veterans, and family services 0 each one rooted in compassion and action.",
    url: "https://www.gfwcmacclenny.org/",
    expanded: false,
    images: [],
  },
  fop: {
    title: "Jacksonville Fraternal Order of Police",
    logo: "../../assets/community/logos/fop.png",
    quote:
      "The mission of the Jacksonville Fraternal Order of Police (FOP) is to enhance the quality of life for its members and the community by advocating for fair working conditions, supporting local charities and projects, and increasing the efficiency of the law enforcement profession.",
    url: "https://www.gfwcmacclenny.org/",
    expanded: false,
    images: [],
  },
  fop: {
    title: "Construction Career Days NE Florida, Inc.",
    logo: "../../assets/community/logos/ccd.png",
    quote:
      "Construction Career Days (CCD) is an exciting annual event that gives high school students an up-close look at the many career opportunities in the construction industry.",
    url: "https://www.nflccd.com/",
    expanded: false,
    images: ["../../assets/community/images/CCD/ccd1.jpg"],
  },
};
